import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const authStore = useAuthStore()
  // No caso de acessar a rota raíz, verifica-se se o utilizar está logado
  if (to.path === '/') {
    if (authStore.isUserAuthenticated) {
      // ? No momento em que o utilizador acessa a rota raíz ele não possui o ID da
      // ? Organização na URL, portanto será redirecionado para a tela de seleção de organizações
      // ? Esta solução é aplicada, pois não há, no momenta da implementação, uma forma melhor para manter o caracter de
      // ? gestão de seleção de organização no frontend
      return navigateTo({ name: 'auth-organization' })
    } else {
      return navigateTo({ name: 'auth-login' })
    }
  }
})
